import { render, staticRenderFns } from "./send-list.vue?vue&type=template&id=1772a4dc&scoped=true&"
import script from "./send-list.vue?vue&type=script&lang=js&"
export * from "./send-list.vue?vue&type=script&lang=js&"
import style0 from "./send-list.vue?vue&type=style&index=0&id=1772a4dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772a4dc",
  null
  
)

export default component.exports